import { useSelector } from "react-redux";

/**
 * Returns a `can(key)` predicate for the current user.
 * Super-admins pass everything; otherwise the key must be in their effective
 * permission set. Use to hide/disable write controls so view-only roles
 * (viewer, moderator) get a true read-only experience — the backend still
 * enforces every write, this is just the UI reflecting it.
 *
 *   const can = usePermission();
 *   {can("feedback.update") && <button>…</button>}
 */
export function usePermission() {
  const is_super_admin = useSelector((s) => s.Profile.is_super_admin);
  const permissions = useSelector((s) => s.Profile.permissions);
  return (key) => is_super_admin || (Array.isArray(permissions) && permissions.includes(key));
}
